"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("./errors");
const Jurisdiction_1 = __importDefault(require("./Jurisdiction"));
class JurisdictionRules {
    constructor(jurisdictions) {
        this.jurisdictions = jurisdictions;
    }
    /**
     * Gets the top-level threshold condition that should be applied to validate an IVMS payload
     *
     * @param countryCode the country code
     * @param amount the transaction amount
     * @returns an array of conditions
     */
    getThresholdCondition(countryCode, amount) {
        const jurisdiction = this.jurisdictions.find((j) => j.countryCode === countryCode);
        if (!jurisdiction) {
            throw new errors_1.JurisdictionNotFound(`Jurisdiction ${countryCode} not found`);
        }
        // Sort thresholds in reverse order i.e highest first and lowest last
        jurisdiction.thresholds.sort((a, b) => b.threshold - a.threshold);
        const threshold = jurisdiction.thresholds.find((t) => t.threshold <= amount);
        if (!threshold) {
            throw new errors_1.ThresholdNotFound(`Threshold for jurisdiction ${countryCode} not found`);
        }
        if (!threshold.conditions[0]) {
            throw new errors_1.ConditionNotFound(`Missing threshold condition for jurisdiction ${countryCode}`);
        }
        threshold.conditions[0].isBelowThreshold =
            threshold.threshold !== undefined &&
                jurisdiction.thresholds.length > 0 &&
                threshold.threshold ===
                    jurisdiction.thresholds[jurisdiction.thresholds.length - 1].threshold;
        return threshold.conditions[0];
    }
    static build(rules) {
        return new JurisdictionRules(rules.map((j) => Jurisdiction_1.default.build(j)));
    }
}
exports.default = JurisdictionRules;
